import React from 'react';
import {
  Swords, Trophy, Medal, Crown, Flame, Star, Shield, Flag, Sparkles, Gavel,
} from 'lucide-react';
import { useI18n } from '../context/I18nContext';

const ICONS = { swords: Swords, trophy: Trophy, medal: Medal, crown: Crown, flame: Flame, star: Star, shield: Shield, flag: Flag, sparkles: Sparkles, gavel: Gavel };

export default function BadgeGrid({ badges = [] }) {
  const { t } = useI18n();
  if (!badges.length) {
    return (
      <div data-testid="badges-empty" className="aura-card p-6 text-center text-sm text-aura-textDim">
        {t('profile.noBadges')}
      </div>
    );
  }
  return (
    <div data-testid="badges-grid" className="grid grid-cols-4 sm:grid-cols-5 gap-3">
      {badges.map((b) => {
        const Icon = ICONS[b.icon] || Sparkles;
        return (
          <div
            key={b.id || b.code}
            title={b.description}
            className="aspect-square flex flex-col items-center justify-center gap-1 aura-card p-2 hover:border-aura-cyan/40 transition"
            data-testid={`badge-${b.code}`}
          >
            <span
              className="grid place-items-center h-10 w-10 rounded-full"
              style={{
                background: `radial-gradient(circle, ${b.color || '#00F0FF'}33 0%, transparent 70%)`,
                boxShadow: `0 0 16px ${b.color || '#00F0FF'}66`,
              }}
            >
              <Icon size={18} style={{ color: b.color || '#00F0FF' }} />
            </span>
            <span className="text-[10px] font-display text-center leading-tight text-white/80 line-clamp-2">{b.name}</span>
          </div>
        );
      })}
    </div>
  );
}
